import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useStepState } from '../../../../components/step/useStepState';
import { TranslationsKeys } from '../../../../locales/translations';

import { AcademicOfferCreate } from '../AcademicOfferCreate';
import { AcademicOfferSchedule } from '../parts/AcademicOfferSchedule';
import { AcademicOfferSections } from '../parts/AcademicOfferSections';
import { AcademicOfferSummary } from '../parts/AcademicOfferSummary';

export function useAcademicOfferCreateSteps() {
  const { t } = useTranslation(
    TranslationsKeys.CONTINUOUS_EDUCATION_ACADEMIC_OFFERS,
  );
  const { currentStep } = useStepState();

  const stepsConfig = useMemo(
    () => [
      {
        id: 'oferta',
        name: t('wizard.steps.oferta'),
        component: AcademicOfferCreate,
      },
      {
        id: 'secciones',
        name: t('wizard.steps.secciones'),
        component: AcademicOfferSections,
      },
      {
        id: 'horario',
        name: t('wizard.steps.horario'),
        component: AcademicOfferSchedule,
      },
      {
        id: 'resumen',
        name: t('wizard.steps.resumen'),
        component: AcademicOfferSummary,
      },
    ],
    [t],
  );

  const availableParts = useMemo(() => {
    const namesSteps: string[] = [];
    const componentsSteps: (React.FunctionComponent | undefined)[] = [];
    stepsConfig.forEach((step) => {
      namesSteps.push(step.name);
      componentsSteps.push(step.component);
    });
    return { namesSteps, componentsSteps };
  }, [stepsConfig]);

  const getIndexStep = useCallback(
    (id: string) => {
      return stepsConfig.findIndex((step) => step.id === id);
    },
    [stepsConfig],
  );

  const CurrentStepComponent = useMemo(() => {
    return availableParts.componentsSteps[currentStep];
  }, [currentStep, availableParts]);

  return {
    stepsConfig,
    ...availableParts,
    CurrentStepComponent,
    getIndexStep,
  };
}
